<!-- <div [innerHTML]="data.contact" mat-dialog-content></div> -->
<h2 mat-dialog-title class="title">{{ title | translate }}</h2>
<ng-container *ngIf="!data.isContact; else contactTemplate">
    <mat-dialog-content>
        <div class="container">
            <p>
                {{ "PRIVACY.MAIN_P.P_LINK" | translate }}
                <a href="https://ticket.angkorenterprise.gov.kh">https://ticket.angkorenterprise.gov.kh</a
        >
      </p>
      <ng-container *ngFor="let item of main_p">
        <p>{{ item | translate }}</p>
      </ng-container>
      <ul class="list">
        <li *ngFor="let item of content">
          <h3>{{ item.title | translate }}</h3>
          <ng-container *ngIf="item?.desc; else other">
            <p *ngIf="item?.desc">{{ item?.desc | translate }}</p>
            <ul class="nested-ul">
              <li *ngFor="let text of item.p">
                <p>{{ text | translate }}</p>
              </li>
            </ul>
          </ng-container>
          <ng-template #other>
            <p *ngFor="let text of item.p">{{ text | translate }}</p>
          </ng-template>
        </li>
      </ul>
    </div>
  </mat-dialog-content>
</ng-container>

<ng-template #contactTemplate>
  <div class="contact-us-container">
    <div mat-dialog-content class="inform-contact">
      <div mat-dialog-content>
        <label>
          <mat-icon matPrefix class="accent">phone</mat-icon>
          <small class="label-h accent">{{
            "LABEL.PHONE_NUMBER" | translate
          }}</small>
        </label>
        <div [innerHTML]="data.contact.phone_number" class="data"></div>
      </div>
  
      <div mat-dialog-content>
        <label>
          <mat-icon matPrefix class="accent">email</mat-icon>
          <small class="label-h accent">{{ "LABEL.E_MAIL" | translate }}</small>
        </label>
        <div [innerHTML]="data.contact.email" class="data"></div>
      </div>
      <div mat-dialog-content>
        <label>
          <mat-icon matPrefix class="accent">location_on</mat-icon>
          <small class="label-h accent">{{
            "LABEL.ADDRESS_LOCATION" | translate
          }}</small>
        </label>
        <p [innerHTML]="data.contact.address" class="data mt-5"></p>
      </div>
    </div>
    <div class="google-map">
      <google-map
        height="350px" 
        width="100%"
        [center]="center"
        [zoom]="zoom"
        [options]="mapOptions"
        (mapInitialized)="onMapReady($event)">
        <map-marker
          [position]="center"
          [options]="markerOptions">
        </map-marker>
      </google-map>
    </div>
  </div>
</ng-template>

<mat-dialog-actions align="end">
  <button
    class="mat-custom-btn"
    mat-dialog-close
    mat-flat-button
    color="accent"
  >
    {{ "LABEL.CLOSE" | translate }}
  </button>
</mat-dialog-actions>